(function () {
  const secondarySlider = document.getElementById('secondary-slider');
    if (!secondarySlider) {
      return;
    }
  const slidesContainerSecondary = secondarySlider.querySelector('.slides');
  const slidesContainerSecondaryText = secondarySlider.querySelector('.slides-secondary');
  const dotsContainerSecondary = secondarySlider.querySelector('.dots');
  const slidesSecondary = slidesContainerSecondary.querySelectorAll('.slide-secondary');
  
  const totalSlidesSecondary = slidesSecondary.length;
  let currentIndexSecondary = 0;
  let startX = 0;
  let isSwiping = false;

  for (let i = 0; i < totalSlidesSecondary; i++) {
    const dot = document.createElement('span');
    dot.classList.add('dot-secondary');
    dot.addEventListener('click', () => moveToSlideSecondary(i));
    dotsContainerSecondary.appendChild(dot);
  }

  const dotsSecondary = secondarySlider.querySelectorAll('.dot-secondary');

  if (!dotsSecondary || !dotsSecondary[currentIndexSecondary]){
    return;
  }
  dotsSecondary[currentIndexSecondary].classList.add('active');

  function moveToSlideSecondary(index) {
    slidesContainerSecondary.style.transform = `translateX(-${index * 100}%)`;
    slidesContainerSecondaryText.style.transform = `translateX(-${index * 100}%)`;
    dotsSecondary[currentIndexSecondary].classList.remove('active');
    dotsSecondary[index].classList.add('active');
    buttonsSecondary[currentIndexSecondary].classList.remove('bg-yellow-300', 'border-yellow-300');
    buttonsSecondary[index].classList.add('bg-yellow-300', 'border-yellow-300');
    currentIndexSecondary = index;
  }

  const buttonsSecondary = document.querySelectorAll('.tabs-secondary button');
  buttonsSecondary.forEach(button => {
    button.addEventListener('click', () => {
      const index = parseInt(button.getAttribute('data-index'));
      moveToSlideSecondary(index);
    });
  });

  // setInterval(() => {
  //     let nextIndex = (currentIndexSecondary + 1) % totalSlidesSecondary;
  //     moveToSlideSecondary(nextIndex);
  // }, 10000);


})();